import { jsx as _jsx } from "react/jsx-runtime";
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { CheckboxLabelGroup } from '../Checkbox/CheckBoxLabelGroup';
import { forwardRef, useMemo } from 'react';
import { RadioCheckIcon } from '../../Icons';
import { Stack } from '../Stack';
import { styled } from '../../system';
export const RadioGroup = forwardRef(({ gap = '$6', flow = 'column', css, children, ...props }, ref) => (_jsx(RadioGroupPrimitive.RadioGroup, { ref: ref, ...props, children: _jsx(Stack, { css: css, flow: flow, gap: gap, children: children }) })));
export const Radio = forwardRef(({ size = 'sm', label, helpText, ...props }, ref) => {
    const hasText = useMemo(() => Boolean(label !== null && label !== void 0 ? label : helpText), [label, helpText]);
    return (_jsx(CheckboxLabelGroup, { helpText: helpText, label: label, size: size, children: _jsx(StyledRadio, { ref: ref, ...props, css: {
                mt: hasText ? '$0dot5' : 0,
                ...props.css
            }, size: size, children: _jsx(StyledIndicator, { children: _jsx(RadioCheckIcon, { width: size === 'sm' ? 6 : 8, height: size === 'sm' ? 6 : 8 }) }) }) }));
});
const StyledRadio = styled(RadioGroupPrimitive.Item, {
    cursor: 'pointer',
    position: 'relative',
    color: '$radioIndicator',
    bgColor: '$radioBg',
    border: '1px solid $radioBorder',
    rounded: '$full',
    flexCenter: true,
    lineHeight: '$none',
    '&:focus:not([data-disabled])': {
        color: '$radioIndicatorFocus',
        bgColor: '$radioBgFocus',
        borderColor: '$radioBorderFocus',
        shadow: '$focusRingPrimary'
    },
    '&:active:not([data-disabled])': {
        color: '$radioIndicatorActive',
        bgColor: '$radioBgActive',
        borderColor: '$radioBorderActive',
        shadow: '$focusRingPrimary'
    },
    '&[data-state="checked"]:not([data-disabled])': {
        color: '$radioIndicatorChecked',
        bgColor: '$radioBgChecked',
        borderColor: '$radioBorderChecked'
    },
    '@hover': {
        '&:hover:not([data-disabled]):not([data-state="checked"])': {
            color: '$radioIndicatorHover',
            bgColor: '$radioBgHover',
            borderColor: '$radioBorderHover'
        }
    },
    '&[data-disabled]': {
        color: '$radioIndicatorDisabled',
        bgColor: '$radioBgDisabled',
        borderColor: '$radioBorderDisabled',
        opacity: 0.8,
        cursor: 'not-allowed'
    },
    variants: {
        size: {
            sm: {
                minMaxSize: '$4'
            },
            md: {
                minMaxSize: '$5'
            }
        }
    },
    defaultVariants: {
        size: 'sm'
    }
});
const StyledIndicator = styled(RadioGroupPrimitive.Indicator, {
    w: '$full',
    h: '$full',
    flexCenter: true,
    lineHeight: '$none',
    position: 'absolute',
    left: 0,
    top: 0
});
RadioGroup.displayName = 'RadioGroup';
Radio.displayName = 'Radio';
